export const getSelectorHtml = selector => {
  if (__CLIENT__) {
    return Array.prototype.slice
      .call(document.querySelectorAll(selector))
      .map(el => (el.innerHTML || '').trim())
      .join('\n');
  }
  throw new Error('cannot use getSelectorHtml when not on the client');
};
